









import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class dateView extends Vue {
  @Prop() value!:string
}
